import {
    COLOR_CATAPULT_BLACK,
    COLOR_CATAPULT_WHITE,
    COLOR_DKSFC_ALERT_RED,
    COLOR_DKSFC_INFORMATION_BLUE,
    COLOR_DKSFC_INFORMATION_BLUE_BG,
    COLOR_DKSFC_SUCCESS_GREEN,
    COLOR_DKSFC_SUCCESS_GREEN_BG,
    COLOR_DKSFC_WARNING_YELLOW,
    COLOR_DKSFC_WARNING_YELLOW_BG,
    COLOR_LTSFC_ALERT_RED,
    COLOR_LTSFC_ALERT_RED_BG,
    COLOR_LTSFC_INFORMATION_BLUE,
    COLOR_LTSFC_INFORMATION_BLUE_BG,
    COLOR_LTSFC_SUCCESS_GREEN,
    COLOR_LTSFC_SUCCESS_GREEN_BG,
    COLOR_LTSFC_WARNING_YELLOW,
    COLOR_LTSFC_WARNING_YELLOW_BG,
    MIN_WIDTH_MD,
} from '@SBGSports/referee-design-tokens';
import { css } from 'linaria';

export const rootFixed = css`
    position: fixed;
    top: 24px;
    right: 24px;
    z-index: 10000;
    pointer-events: none;

    @media screen and (max-width: ${MIN_WIDTH_MD - 1}px) {
        width: 100%;
        padding: 24px 24px 0 24px;
        top: auto;
        bottom: 0;
        left: auto;
        right: auto;
    }
`;

export const alertDismissButton = css`
    max-height: 18px;
    max-width: 18px;
    pointer-events: all;
    z-index: 20000;
    margin: 10px;
`;

export const alertCancelContent = css`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    flex-grow: 1;
`;
export const alertItem = css`
    position: relative;
    color: ${COLOR_CATAPULT_BLACK};
    background: ${COLOR_CATAPULT_WHITE};
    width: 384px;
    max-width: 100%;
    pointer-events: all;

    transition: all 200ms cubic-bezier(0.25, 0.46, 0.45, 0.94);

    transform: translate3d(150%, 0, 0);

    border-radius: 4px;
    margin-bottom: 15px;

    @media screen and (max-width: ${MIN_WIDTH_MD - 1}px) {
        width: 100%;
    }

    box-shadow: 0px 7px 8px -4px rgba(16, 16, 16, 0.2), 0px 12px 17px 2px rgba(16, 16, 16, 0.14),
        0px 5px 22px 4px rgba(16, 16, 16, 0.12);
    margin-bottom: 16px;
    display: flex;
    flex-direction: row;
`;

export const open = css`
    transform: translate3d(0, 0, 0);
`;

export const darkModeAlert = css`
    background: ${COLOR_CATAPULT_BLACK};
    color: ${COLOR_CATAPULT_WHITE};
`;

export const alertContent = css`
    align-items: top;
    display: flex;
    padding: 24px;
    transition: opacity 200ms linear;
    width: 100%;

    & svg {
        flex-shrink: 0;
    }
`;

export const alertTitle = css`
    font-size: 14px;
    margin: 0 0 8px 0;
`;

export const alertMessage = css`
    padding: 0 10px;
    font-size: 14px;
    flex-grow: 1;
`;

export const inlineBase = css`
    display: inline-block;
    box-shadow: none;
    animation: none;
`;

export const inlineAlert = css`
    background: ${COLOR_LTSFC_INFORMATION_BLUE_BG};
    border: 1px solid ${COLOR_LTSFC_INFORMATION_BLUE};
`;

export const inlineDarkAlert = css`
    background: ${COLOR_DKSFC_INFORMATION_BLUE_BG};
    border: 1px solid ${COLOR_DKSFC_INFORMATION_BLUE};
`;

export const inlineErrorStyle = css`
    background: ${COLOR_LTSFC_ALERT_RED_BG};
    border: 1px solid ${COLOR_LTSFC_ALERT_RED};
`;

export const inlineDarkErrorStyle = css`
    background: #130202;
    border: 1px solid ${COLOR_DKSFC_ALERT_RED};
`;

export const inlineSuccessStyle = css`
    background: ${COLOR_LTSFC_SUCCESS_GREEN_BG};
    border: 1px solid ${COLOR_LTSFC_SUCCESS_GREEN};
`;

export const inlineDarkSuccessStyle = css`
    background: ${COLOR_DKSFC_SUCCESS_GREEN_BG};
    border: 1px solid ${COLOR_DKSFC_SUCCESS_GREEN};
`;

export const inlineWarningStyle = css`
    background: ${COLOR_LTSFC_WARNING_YELLOW_BG};
    border: 1px solid ${COLOR_LTSFC_WARNING_YELLOW};
`;

export const inlineDarkWarningStyle = css`
    background: ${COLOR_DKSFC_WARNING_YELLOW_BG};
    border: 1px solid ${COLOR_DKSFC_WARNING_YELLOW};
`;

export const actionBar = css`
    align-items: center;
    justify-content: flex-end;
    display: flex;
    gap: 12px;
    margin-right: -66px;
    padding-top: 1em;
    position: relative;
`;

export const actionBarButton = css`
    margin-left: -16px;
`;
